import React, { useEffect, useState } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import theme from 'shared/styles/theme';

import Backspace from './Backspace';

export interface NumberPadButtonProps {
  number: string;
  handleButtonPress: (s: string | undefined) => void;
  disabled: boolean;
}

export const DELETE = 'DELETE';

const NumberPadButton = ({
  number,
  disabled,
  handleButtonPress,
}: NumberPadButtonProps) => {
  const [pressed, setPressed] = useState<string | undefined>(undefined);

  const handlePressIn = (number: string) => {
    handleButtonPress(number);
    setPressed(number);
  };

  useEffect(() => {
    setTimeout(() => {
      if (pressed !== undefined) {
        setPressed(undefined);
      }
    }, 100);
  }, [pressed]);

  if (number === DELETE) {
    return (
      <Pressable
        testID={DELETE}
        onPressIn={!disabled ? () => handlePressIn(DELETE) : null}
        onPressOut={!disabled ? () => setPressed(undefined) : null}
        style={
          !disabled && pressed === DELETE
            ? style.pressablePressedStyle
            : style.pressableStyle
        }
        role="button"
        accessible
      >
        <Backspace
          iconSize={125}
          iconColor={
            disabled ? theme.color.text.tertiary : theme.color.text.primary
          }
        />
      </Pressable>
    );
  } else if (!disabled && pressed === number) {
    return (
      <Pressable
        onPress={() => {}}
        onPressIn={!disabled ? () => handlePressIn(number) : null}
        onPressOut={!disabled ? () => setPressed(undefined) : null}
        style={style.pressablePressedStyle}
        testID={`num-${number}`}
        role="button"
        accessible
      >
        <TitleLgText>{number}</TitleLgText>
      </Pressable>
    );
  }
  return (
    <Pressable
      onPress={() => {}}
      onPressIn={!disabled ? () => handlePressIn(number) : null}
      onPressOut={!disabled ? () => setPressed(undefined) : null}
      accessible
      style={style.pressableStyle}
      testID={`num-${number}`}
      role="button"
    >
      <TitleMdText style={disabled && style.disabledStyle}>
        {number}
      </TitleMdText>
    </Pressable>
  );
};

const style = StyleSheet.create({
  disabledStyle: {
    color: theme.color.text.tertiary,
  },
  pressablePressedStyle: {
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.color.background.secondary,
    flexWrap: 'nowrap',
    height: 56,
    justifyContent: 'center',
    width: '100%',
  },
  pressableStyle: {
    alignContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap',
    height: 56,
    justifyContent: 'center',
    width: '100%',
  },
});

export default NumberPadButton;
